module.exports = __webpack_public_path__ + "img/117-6ac51c.png";